import AccordionSelectV2 from "components/AccordionSelect/AccordionSelectV2";
import AccordionSelectV3 from "components/AccordionSelect/AccordionSelectV3";
import CrossMarkAlt from "components/Icons/CrossMarkAlt";
import Info, { InfoIconAlt } from "components/Icons/Info";
import PlusAlt from "components/Icons/PlusAlt";
import UICreatePDSelect, { NewPDValue } from "components/Others/UICreatePDSelect";
import UIPDSelect, { PDOption } from "components/Others/UIPDSelect";
import UITooltip from "components/Others/UITooltip";
import { isMultifocalPrescription } from "functions/multifocal";
import Link from "next/link";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGuestPrescription, setPds, setPrescriptions, setSelectBoxPrescription, setSelectedPrescription, setUsePrescriptionButton } from "redux/features/prescription/prescriptionSlice";
import { RootState } from "redux/store";
import { useGlassesStore } from "zus/glassesStore";
import { setShowModal, setUseThisPD } from 'redux/features/pd/pdSlice';
import UIButton from "components/Others/UIButton";
import { useProductStore } from "zus/productStore";
import prescriptionService from "services/prescription.service";
import { CREATE_PD, CREATE_PRESCRIPTION_AND_PD } from "gqlStrings/mutations/Prescription";
import { useMutation } from "@apollo/client";
import { addDataLayer } from "lib/ga";
import toast from "react-hot-toast";
import { notifications } from "constants/notificationMessages";
import { showWarningMessage } from "utils/toast.util";
import LensDeBlur from "components/Icons/LensDeBlur";
import { useRouter } from "next/router";
import PrescriptionMarkChecked from "components/Icons/PrescriptionMarkChecked";
import PrescriptionMarkUnChecked from "components/Icons/PrescriptionMarkUnChecked";
import LensMeasure from "components/Icons/LensMeasure";

export default function PrescriptionFormUpdatePD({ isProfilePage = false }) {
  const dispatch = useDispatch();
  const lensPurposeList = useGlassesStore((state) => state.purpose_options);
  const purposeZ = useGlassesStore((state) => state.purpose);
  const isLogin = useSelector((state: RootState) => state.authEvent.isLogin);
  const frameSize = useGlassesStore((state) => state.frame_size)
  const armsSize = useGlassesStore((state) => state.arms_size)
  const setSkipPd = useGlassesStore((state) => state.setSkipPd);
  const setAvailibility = useGlassesStore((state) => state.setAvailibility);
  const setSelectedPD = useGlassesStore((state) => state.setSelectedPD);
  const setPrescriptionShowStep = useProductStore((state: any) => state.setPrescriptionShowStep);

  const mySavedPdRef = useRef<HTMLDivElement>(null);
  const enterNewPdRef = useRef<HTMLDivElement>(null);
  const iDontKnowPdRef = useRef<HTMLDivElement>(null);
  const IneedHelpPdRef = useRef<HTMLDivElement>(null);
  const setActiveSelection = useProductStore((state: any) => state.setActiveSelection)
  const setActiveSelectionIdx = useProductStore((state: any) => state.setActiveSelectionIdx)

  const priscriptionFormValues = useProductStore((state: any) => state.priscriptionFormValues)
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true)

  const pds = useSelector((state: RootState) => state.prescriptionEvent.pds);
  const [file, setFile] = useState(null);

  const usePDMeter = useSelector((state: any) => state.pdEvent.setPD)
  const calculatedPd = useSelector((state: any) => state.pdEvent.calculatedPd)
  const router = useRouter();

  const prescriptionEmail = useGlassesStore((state) => state.prescription_email);
  const haveUsCallOptometrist = useGlassesStore((state) => state.have_us_call_optometrist);
  const pdNotExists = useProductStore((state: any) => state.pdNotExists);
  const setPdNotExists = useProductStore((state: any) => state.setPdNotExists);
  const frameShape = useGlassesStore((state) => state.frame_shape);

  const guestData = !isLogin ? JSON.parse(localStorage.getItem('userPdSelection') as string) : null;
  const [newPd, setNewPd] = useState<NewPDValue>(guestData?.type ? guestData : {
    type: 'bino',
    left: '',
    right: '',
    pd: '',
    source: 'we'
  });
  const [isAddLoading, setIsAddLoading] = useState(false);
  const [pdList, setPdList] = useState<PDOption[]>(pds);

  function select(pd: any) {
    //selectPd?.(pd);
    dispatch(setUsePrescriptionButton(true));
  }
  const [pdFormViewType, setPdFormViewType] = useState(
    pds.length > 0 ? 'MY_SAVED_PD' : 'I_KNOW_PD'
  );

  const [isRequiesting, setIsRequesting] = useState(false);
  const [isPdListLoading, setIsPdListLoading] = useState(true);

  const [mutatePdFunction] = useMutation(CREATE_PD, {
    context: { clientName: 'laravel' },
    onCompleted: async (getUserData) => {
      const Newpds = Object.assign([], pds);
      Newpds.unshift(getUserData.createPd);
      dispatch(setPds(Newpds));
      select(getUserData.createPd);
      setIsAddLoading(false);
    },
    onError: () => {
      setIsAddLoading(false);
    }
  });

  const [isPrescriptionUpdateLoading, setIsPrescriptionUpdateLoading] =
    useState(false);


  const selectedPrescription = useSelector(
    (state: RootState) => state.prescriptionEvent.selectedPrescription
  );

  const selectBoxPrescription = useSelector(
    (state: RootState) => state.prescriptionEvent.selectBoxPrescription
  );

  const [prescriptionPdMap, setPrescriptionPdMap] = useState<
    Record<string, string>
  >({});

  const prescriptions = useSelector(
    (state: RootState) => state.prescriptionEvent.prescriptions
  );


  const handleValidation = () => {

    setIsConfirmDisabled(() => true);

    if (pdFormViewType == 'I_KNOW_PD') {
      if (newPd.type === 'bino' && newPd.pd) return setIsConfirmDisabled(() => false)
      if (newPd.type === 'mono' && (newPd.left && newPd.right)) return setIsConfirmDisabled(() => false)
    } else if (pdFormViewType == 'MY_SAVED_PD') {
      if (selectedPdId) return setIsConfirmDisabled(() => false)
    }
  }
  const [selectedPdId, setSelectedPdId] = useState(selectedPrescription?.pd?.id);

  const [pdType, setPdType] = useState('single');


  function setSelectPd(pd: any) {
    // dispatch(setPdSelectPrescriptionId(null));
    dispatch(setUsePrescriptionButton(true));
    dispatch(setSelectBoxPrescription({ ...selectBoxPrescription, pd: { ...pd } }));
  }

  useEffect(() => {
    if (handleValidation) handleValidation();
  }, [newPd, selectedPdId])

  useEffect(() => {
    addDataLayer({ event: 'Step_RX_PD' });
  }, []);

  useEffect(() => {
    if (
      (purposeZ == 'multifocal' || purposeZ == 'bifocal') &&
      selectedPrescription &&
      !isMultifocalPrescription(selectedPrescription)
    ) {
      dispatch(setSelectedPrescription(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purposeZ]);

  const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const yOffset = -120; // Adjust this value based on your header height
      const element = ref.current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      
      setTimeout(() => {
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }, 100);
    }
  };

  useEffect(() => {
    if (pdFormViewType === 'MY_SAVED_PD' && mySavedPdRef.current) {
      scrollToRef(mySavedPdRef);
    } else if (pdFormViewType === 'I_KNOW_PD' && enterNewPdRef.current) {
      scrollToRef(enterNewPdRef);
    } else if (pdFormViewType === 'I_DONT_KNOW_PD' && iDontKnowPdRef.current) {
      scrollToRef(iDontKnowPdRef);
    } else if (pdFormViewType === 'I_NEED_HELP_PD' && IneedHelpPdRef.current) {
      scrollToRef(IneedHelpPdRef);
    }
  }, [pdFormViewType]);

  useEffect(() => {
    if (usePDMeter) {
      const calculatedSize = (calculatedPd / 2) % 0.5 != 0 ? ((calculatedPd / 2) + 0.25) : (calculatedPd / 2);
      if (newPd.type == 'mono') {
        setNewPd(Object.assign({}, newPd, { "left": calculatedSize + '', "right": calculatedSize + '', "source": "o-pm" }))
      } else {
        setNewPd(Object.assign({}, newPd, { "pd": calculatedPd, "source": "o-pm" }))
      }

      localStorage.setItem('calculatedPd', JSON.stringify({ 'pd': calculatedPd, 'monoPD': calculatedSize + '' }))
      dispatch(setUseThisPD(false))
    }
  }, [usePDMeter])

  const setPurpose = useGlassesStore((state) => state.setPurpose)
  //console.log('PurposeComponent purpose', purposeZ);
  //if (lensPurposeList === undefined) return null;

  // if there is no purpose, return null
  //if (lensPurposeList.length === 0) return null;

  // if there is only one purpose, set it as the default
  if (lensPurposeList && lensPurposeList.length === 1 && purposeZ != lensPurposeList[0].slug) {
    setPurpose(lensPurposeList[0]);
  }
  if (lensPurposeList && lensPurposeList.length === 1) {
    return null;
  }


  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [mutatePrescriptionFunction] = useMutation(CREATE_PRESCRIPTION_AND_PD, {
    context: {
      clientName: 'laravel',
      upload: true
    },
    onCompleted: async (getUserData) => {
      addDataLayer({ event: 'prescription_success' }, false);
      if (isLogin) {
        const NewPrescription = Object.assign([], prescriptions);
        NewPrescription.unshift(getUserData.createPrescriptionAndPd);
        dispatch(setPrescriptions(NewPrescription));
        const updatedPds = await prescriptionService.findAllPds(
          frameSize as string
        );
        dispatch(setPds(updatedPds));
      }else{
        dispatch(setGuestPrescription(true));
      }


      dispatch(setSelectedPrescription(getUserData.createPrescriptionAndPd));
      dispatch(setSelectBoxPrescription(getUserData.createPrescriptionAndPd));
      dispatch(setUsePrescriptionButton(true));
      //setCreatePrescriptionLoading(false);

      dispatch(setSelectedPrescription({ ...getUserData.createPrescriptionAndPd, pd: getUserData.createPrescriptionAndPd.pd }));
      setActiveSelection("lens")
      setActiveSelectionIdx(3)
      router.push('#lens')
      setPrescriptionShowStep('SHOW_SELECTIONS');
      setIsRequesting(() => false);
      if (!isLogin) {
        document
          .getElementsByTagName('body')[0]
          .classList.remove('overflow-hidden-body');

      }

      if (router.asPath.includes('prescriptions/add')) {
        toast.custom((t) => (
          <div
            onClick={() => toast.dismiss(t.id)}
            className={`${t.visible ? 'animate-enter' : 'animate-leave'
              } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-green p-4 text-center text-sm font-medium text-white shadow-lg`}>
            {notifications.CREATE_PRESCRIPTION}
          </div>
        ));
      }
    },
    onError: (error) => {
      addDataLayer({ event: 'prescription_fail' }, false);
      //setCreatePrescriptionLoading(false);
      toast.custom((t) => (
        <div
          onClick={() => toast.dismiss(t.id)}
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-red p-4 text-center text-sm font-medium text-white shadow-lg`}>
          {error.message}
        </div>
      ));
    }
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [mutatePDFunction] = useMutation(CREATE_PD, {
    context: {
      clientName: 'laravel',
      upload: true
    },
    onCompleted: async (getUserData) => {
      addDataLayer({ event: 'pd_success' }, false);

      if (pdNotExists) {
        await prescriptionService.updatePdById({
          pdId: String(prescriptionPdMap[selectedPrescription.id]),
          prescriptionId: selectedPrescription.id
        });
        dispatch(setSelectedPrescription({ ...selectedPrescription, pd: getUserData.createPd }));
        setPdNotExists(false);
        setActiveSelection("lens")
        setActiveSelectionIdx(3)
        router.push('#lens');
        setPrescriptionShowStep('SHOW_SELECTIONS');
        setSelectedPD(getUserData.createPd);
        return;
      }
      if (selectedPrescription) {
        await prescriptionService.updatePdById({
          pdId: String(prescriptionPdMap[selectedPrescription.id]),
          prescriptionId: selectedPrescription.id
        });
        dispatch(setSelectedPrescription({ ...selectedPrescription, pd: getUserData.createPd }));
      }
      setActiveSelection("lens")
      setActiveSelectionIdx(3)
      router.push('#lens')
      setSelectedPD(getUserData.createPd);
      setIsRequesting(() => false);

      if (!isLogin) {
        document
          .getElementsByTagName('body')[0]
          .classList.remove('overflow-hidden-body');
      } else {
        const Newpds = Object.assign([], pds);
        Newpds.unshift(getUserData.createPd);
        dispatch(setPds(Newpds));
      }


      setPrescriptionShowStep('SHOW_SELECTIONS');
    },
    onError: (error) => {
      addDataLayer({ event: 'pd_fail' }, false);
      //setCreatePrescriptionLoading(false);
      toast.custom((t) => (
        <div
          onClick={() => toast.dismiss(t.id)}
          className={`${t.visible ? 'animate-enter' : 'animate-leave'
            } flex w-[300px] cursor-default select-none items-center justify-center rounded bg-brand-red p-4 text-center text-sm font-medium text-white shadow-lg`}>
          {error.message}
        </div>
      ));
    }
  });

  const skipPd = () => {
    setSkipPd(true);
    if (prescriptionEmail || haveUsCallOptometrist) {
      setActiveSelection("lens");
      setActiveSelectionIdx(3);
      router.push('#lens');
      dispatch(setSelectedPrescription(null));
      return;
    }

    if (selectedPrescription) {
      setActiveSelection("lens");
      setActiveSelectionIdx(3);
      router.push('#lens');
      return;
    }

    const formval = priscriptionFormValues;
    if (priscriptionFormValues?.fromUpload) {
      return mutatePrescriptionFunction({
        variables: {
          input: {
            note: priscriptionFormValues?.note,
            pdType: 'single',
            add_type: 'monocular',
            file: priscriptionFormValues.file,
            binocular_dist_pd: '0',
            right_monocular_dist_pd: '0',
            left_monocular_dist_pd: '0',
            skip_pd: true,
            glass_shape_type: frameShape
          }
        }
      })
    } else {
      return mutatePrescriptionFunction({
        variables: {
          input: {
            left_near_add: formval?.addL,
            right_near_add: formval?.addR,
            right_sph: formval?.sphereR,
            left_axis: formval?.axisL || '0',
            left_cyl: formval?.cylinderL,
            left_sph: formval?.sphereL,
            right_axis: formval?.axisR || '0',
            right_cyl: formval?.cylinderR,
            note: formval?.note,
            pdSource: newPd.source,
            binocular_dist_pd: newPd.pd,
            right_monocular_dist_pd: newPd.right,
            left_monocular_dist_pd: newPd.left,
            add_type: 'monocular',
            frame_size: formval?.frameSize,
            arm_size: formval?.armsSize,
            file: formval?.file,
            pdType: 'single',
            skip_pd: true,
            glass_shape_type: frameShape
          }
        }
      });
    }
  }

  const saveOnlyPD = () => {
    if (pdFormViewType === 'MY_SAVED_PD') {
      let pd = pdList.filter((pd: any) => pd !== null).find((pd: any) => pd.id === selectedPdId);
      if (pd) {
        setSelectedPD(pd);
        addDataLayer({ event: 'pd_success' }, false);
        setActiveSelection("lens")
        setActiveSelectionIdx(3)
        router.push('#lens')
        setIsRequesting(() => false);
      }
    } else if (pdFormViewType === 'I_KNOW_PD') {
      mutatePDFunction({
        variables: {
          input: {
            pdType: newPd.type === 'bino' ? 'single' : 'multi',
            binocular_dist_pd: newPd.pd,
            right_monocular_dist_pd: newPd.right,
            left_monocular_dist_pd: newPd.left,
            glass_shape_type: frameShape
          }
        }
      });
    }
  }

  const handleConfirmPD = async () => {
    if (selectedPrescription) {
      setIsPrescriptionUpdateLoading(true);
      setIsRequesting(true);

      if (pdFormViewType === 'MY_SAVED_PD') {
        await prescriptionService.updatePdById({
          pdId: String(selectedPdId),
          prescriptionId: selectedPrescription.id
        });
        dispatch(setSelectedPrescription({ ...selectedPrescription, pd: pds.filter((pd: any) => pd !== null).find((pd: any) => pd.id === selectedPdId) }));
        setPdNotExists(false);
        setActiveSelection("lens");
        setActiveSelectionIdx(3);
        router.push('#lens');
      } else if (pdFormViewType === 'I_KNOW_PD') {
        mutatePDFunction({
          variables: {
            input: {
              pdType: newPd.type === 'bino' ? 'single' : 'multi',
              binocular_dist_pd: newPd.pd,
              right_monocular_dist_pd: newPd.right,
              left_monocular_dist_pd: newPd.left,
              glass_shape_type: frameShape
            }
          }
        });
      }
      setPrescriptionShowStep('SHOW_SELECTIONS');
      setIsPrescriptionUpdateLoading(false);
      setIsRequesting(false);
      return;
    }



    setSkipPd(false);
    setIsPrescriptionUpdateLoading(true);
    setIsRequesting(true);
    setPrescriptionShowStep('SHOW_SELECTIONS');
    localStorage.setItem('userPdSelection', JSON.stringify(newPd));

    if (prescriptionEmail || haveUsCallOptometrist) {
      saveOnlyPD();
      return;
    }

    const commonInputs = {
      note: priscriptionFormValues?.note || selectedPrescription?.note,
      frame_size: frameSize || priscriptionFormValues?.frameSize,
      arm_size: armsSize || priscriptionFormValues?.armsSize,
      file: priscriptionFormValues?.file || file,
      add_type: 'monocular',
      skip_pd: false,
      glass_shape_type: frameShape
    };

    const prescriptionInputs = {
      left_near_add: priscriptionFormValues?.addL || selectedPrescription?.left_near_add,
      right_near_add: priscriptionFormValues?.addR || selectedPrescription?.right_near_add,
      right_sph: priscriptionFormValues?.sphereR || selectedPrescription?.right_sph,
      left_axis: priscriptionFormValues?.axisL || selectedPrescription?.left_axis || '0',
      left_cyl: priscriptionFormValues?.cylinderL || selectedPrescription?.left_cyl,
      left_sph: priscriptionFormValues?.sphereL || selectedPrescription?.left_sph,
      right_axis: priscriptionFormValues?.axisR || selectedPrescription?.right_axis || '0',
      right_cyl: priscriptionFormValues?.cylinderR || selectedPrescription?.right_cyl,
    };

    let pdInputs = {};

    if (pdFormViewType === 'MY_SAVED_PD') {
      pdInputs = {
        pdId: String(selectedPdId),
        pdType: pdType,
      };
    } else if (pdFormViewType === 'I_KNOW_PD') {
      pdInputs = {
        pdType: newPd.type === 'bino' ? 'single' : 'multi',
        pdSource: newPd.source,
        binocular_dist_pd: newPd.pd,
        right_monocular_dist_pd: newPd.right,
        left_monocular_dist_pd: newPd.left,
      };
    }

    const input = {
      ...commonInputs,
      ...(priscriptionFormValues?.fromUpload ? {} : prescriptionInputs),
      ...pdInputs,
    };

    return mutatePrescriptionFunction({
      variables: { input },
    });
  };

  return (
    <><div>
      {!isProfilePage && <h5 className="font-medium text-center border-b border-brand-grey500 text-black pb-8 text-2xl mt-10 ">
        Your Pupillary Distance (PD)
      </h5>}
      <div className="mt-[21px] grid-cols-[1fr,4fr] mdx:grid-cols-1 mdx:gap-[15px]">
        <div className="flex flex-col relative border-b border-brand-grey500 lg:pb-6">
          <>
            {isLogin && (
              <div ref={mySavedPdRef} className="mt-[24px] bg-[#fff] border border-[#EAEAEA] px-[24px] py-[16px] rounded-[6px]">
                <div className="flex">
                  <div className="flex gap-[24px] items-center flex-1 cursor-pointer" onClick={() => {
                    setPdFormViewType('MY_SAVED_PD');
                  }}>
                    {pdFormViewType === 'MY_SAVED_PD' ? <PrescriptionMarkChecked /> : <PrescriptionMarkUnChecked />}
                    <div>
                      <p className="text-[#2A2A2A] text-[16px] font-semibold">I will select my saved PD</p>
                    </div>
                  </div>
                  {pdFormViewType === 'MY_SAVED_PD' && (
                    <div>
                      <UITooltip
                        id="pd-upload-pd"
                        border={true}
                        borderColour={'#D7D8D7'}
                        textColour={'#000'}
                        backgroundColour={'#FFF'}
                        message={
                          <div>
                            <p className="font-normal">
                              Pupil distance (PD) measures the space between the
                              pupils of your eyes.
                            </p>
                            <Link href="/our-glasses/measure-your-pd" target="_blank">
                              <span
                                className="mt-[4px] text-[12px] font-medium transition-colors hover:text-brand-orange">
                                How to measure your PD?
                              </span>
                            </Link>
                          </div>
                        }
                        place="top"
                        wrapperClassName="mt-[2px] ml-[12px]">
                        <Info className="cursor-pointer" />
                      </UITooltip>
                    </div>
                  )}
                </div>
                {pdFormViewType === 'MY_SAVED_PD' && (
                  <div className="ml-[52px] mt-[24px]">
                    {pdList && pdList.filter((pd: any) => pd !== null).map((pd: any) => (
                      <div key={pd.id}
                        className="flex items-center mb-[16px] cursor-pointer "
                        onClick={() => setSelectedPdId(pd.id)}>

                        <div className="mr-[8px]">
                          {selectedPdId === pd.id ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                              <circle cx="9.5" cy="9" r="8.5" fill="white" />
                              <circle cx="9.5" cy="9" r="8.5" fill="white" />
                              <circle cx="9.5" cy="9" r="8.5" stroke="#CACACA" />
                              <circle cx="9.5" cy="9" r="6" fill="#FF8200" />
                            </svg>
                          ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                              <circle cx="9.5" cy="9" r="8.5" fill="white" />
                              <circle cx="9.5" cy="9" r="8.5" fill="white" />
                              <circle cx="9.5" cy="9" r="8.5" stroke="#CACACA" />
                            </svg>
                          )}
                        </div>
                        <div className="flex items-center justify-start w-full">
                          {pd.binocular_dist_pd != null ? (
                            <p className="text-[#616161] text-[14px] font-normal">{pd.binocular_dist_pd} <span className="mx-1">-</span> </p>
                          ) : (
                            <p className="text-[#616161] text-[14px] font-normal">Right {pd.right_monocular_dist_pd} / Left {pd.left_monocular_dist_pd} <span className="mx-1">-</span> </p>
                          )}

                          <p className="text-[#959595] text-[14px] font-normal"> (Created on {new Date(pd.created_at).toLocaleDateString('en-GB').replaceAll('/', '.')}) </p>
                        </div>
                      </div>
                    ))}
                    <UIButton onClick={handleConfirmPD} loading={isRequiesting} disabled={isConfirmDisabled} className=" whitespace-nowrap lg:mt-8 lgx:mt-4">Select PD</UIButton>
                  </div>
                )}
              </div>
            )}

            <div ref={enterNewPdRef} className="mt-[12px] bg-[#fff] border border-[#EAEAEA] px-[24px] py-[16px] rounded-[6px]">
              <div className="flex">
                <div className="flex gap-[24px] items-center flex-1 cursor-pointer" onClick={() => {
                  setPdFormViewType('I_KNOW_PD');
                }}>
                  {pdFormViewType === 'I_KNOW_PD' ? <PrescriptionMarkChecked /> : <PrescriptionMarkUnChecked />}
                  <div>
                    {isLogin ? (
                      <p className="text-[#2A2A2A] text-[16px] font-semibold">I have a new PD, I will enter it</p>
                    ) : (
                      <p className="text-[#2A2A2A] text-[16px] font-semibold">I know my PD</p>
                    )}
                  </div>
                </div>
                {pdFormViewType === 'I_KNOW_PD' && (
                  <div>
                    <UITooltip
                      id="pd-upload-pd"
                      border={true}
                      borderColour={'#D7D8D7'}
                      textColour={'#000'}
                      backgroundColour={'#FFF'}
                      message={
                        <div>
                          <p className="font-normal">
                            Pupil distance (PD) measures the space between the
                            pupils of your eyes.
                          </p>
                          <Link href="/our-glasses/measure-your-pd" target="_blank">
                            <span
                              className="mt-[4px] text-[12px] font-medium transition-colors hover:text-brand-orange">
                              How to measure your PD?
                            </span>
                          </Link>
                        </div>
                      }
                      place="top"
                      wrapperClassName="mt-[2px] ml-[12px]">
                      <InfoIconAlt className="cursor-pointer" />
                    </UITooltip>
                  </div>
                )}
              </div>
              {pdFormViewType === 'I_KNOW_PD' && (
                <div className="ml-[52px] mt-[24px]">
                  <UICreatePDSelect
                    frameSize={frameSize as any}
                    value={newPd}
                    onChange={setNewPd}
                  />

                  <UIButton dataTestId="confirm-pd-button" onClick={handleConfirmPD} loading={isRequiesting} disabled={isConfirmDisabled} className=" whitespace-nowrap lg:mt-8 lgx:mt-4">Confirm PD</UIButton>
                </div>
              )}
            </div>

            <div ref={iDontKnowPdRef} className="bg-[#fff] border border-[#EAEAEA] px-[24px] py-[16px] rounded-[6px] mt-[12px]">
              <div className="flex">
                <div className="flex gap-[24px] items-center flex-1 cursor-pointer" onClick={() => {
                  setPdFormViewType('I_DONT_KNOW_PD');
                }}>
                  {pdFormViewType === 'I_DONT_KNOW_PD' ? <PrescriptionMarkChecked /> : <PrescriptionMarkUnChecked />}
                  <div>
                    <p className="text-[#2A2A2A] text-[16px] font-semibold">{`I don't know my PD, I will measure it`}</p>
                  </div>
                </div>
              </div>

              {pdFormViewType === 'I_DONT_KNOW_PD' && (
                <div className="ml-[52px] mt-[24px]">
                  <div className="mb-6 border-b border-[#EAEAEA]">
                    <h3 className="font-semibold mb-[12px] text-[#2A2A2A] text-[14px]">Measure your PD with our Online PD tool</h3>
                    <p className="text-[#959595] text-[14px] mb-[12px]">
                      Use our online tool to easily measure your pupillary distance.
                      Then, continue with your order by entering your PD.
                    </p>
                    <a className="flex relative text-brand-blue leading-8 cursor-pointer" onClick={() => {
                      dispatch(setShowModal(true));
                      setPdFormViewType('I_KNOW_PD');
                    }}><LensDeBlur width={30} className="mr-1 relative -top-1.5" fill="#00aec7" /> Measure your PD size</a>
                  </div>

                  <div className="mb-6 border-b border-[#EAEAEA]">
                    <h3 className="font-semibold mb-[12px] text-[#2A2A2A] text-[14px]">Measure your PD manually</h3>
                    <p className="text-[#959595] text-[14px] mb-[12px]">
                      Measure your pupillary distance yourself.
                      Then, continue with your order by entering your PD.
                    </p>
                    <Link
                      href="/our-glasses/measure-your-pd"
                      target="_blank"
                      className="flex relative text-brand-blue leading-8 cursor-pointer" >
                      <LensMeasure width={30} className="mr-1 relative -top-1.5" fill="#00aec7" /> Measure your PD manually
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <div ref={IneedHelpPdRef} className="mt-[12px] bg-[#fff] border border-[#EAEAEA] px-[24px] py-[16px] rounded-[6px]">
              <div className="flex">
                <div className="flex gap-[24px] items-center flex-1 cursor-pointer" onClick={() => {
                  setPdFormViewType('I_NEED_HELP_PD');
                }}>
                  {pdFormViewType === 'I_NEED_HELP_PD' ? <PrescriptionMarkChecked /> : <PrescriptionMarkUnChecked />}
                  <div>
                    <p className="text-[#2A2A2A] text-[16px] font-semibold">I need help with my PD</p>
                  </div>
                </div>
                {pdFormViewType === 'I_NEED_HELP_PD' && (
                  <div>
                    <UITooltip
                      id="pd-upload-pd"
                      border={true}
                      borderColour={'#D7D8D7'}
                      textColour={'#000'}
                      backgroundColour={'#FFF'}
                      message={
                        <div>
                          <p className="font-normal">
                            Pupil distance (PD) measures the space between the
                            pupils of your eyes.
                          </p>
                          <Link href="/our-glasses/measure-your-pd" target="_blank">
                            <span
                              className="mt-[4px] text-[12px] font-medium transition-colors hover:text-brand-orange">
                              How to measure your PD?
                            </span>
                          </Link>
                        </div>
                      }
                      place="top"
                      wrapperClassName="mt-[2px] ml-[12px]">
                      <InfoIconAlt className="cursor-pointer" />
                    </UITooltip>
                  </div>
                )}
              </div>
              {pdFormViewType === 'I_NEED_HELP_PD' && (
                <div className="ml-[52px] mt-[12px]">
                  <div className="mb-6">
                    <p className="text-[#959595] text-[14px] mb-[12px]">
                      {`
                       Don't worry about your PD value for now. Once you finish placing
                       your order, we will contact you to find your PD value.
                     `}
                    </p>
                  </div>

                  <button onClick={skipPd} className="mb-[10px] w-[200px] bg-[#2A2A2A] text-white py-3 rounded-md hover:bg-gray-700 transition duration-300">
                    Skip PD
                  </button>
                </div>
              )}
            </div>
          </>
        </div>
      </div>
    </div>
    </>);
}
